import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "primereact/button";
import "./../Login.scss";
import LogoImg from "../../../Images/zbizLogo.png";
import { useFormik } from "formik";
import { handlePostRequest } from "../../../services/PostTemplate";
import styled from "styled-components";

const SubmitOTP = ({ handleSubmitOtp, jwtToken }) => {
  let history = useHistory();

  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("pi pi-save");
  // const [hasRequestedOTP, setHasRequestedOTP] = useState(false);

  const otpRefs = useRef([]);
  const addRef = (el) => {
    if (el && !otpRefs.current.includes(el)) {
      otpRefs.current.push(el);
    }
  };

  const handleInputChange = (e, index) => {
    formik.setFieldValue(`otp${index + 1}`, e.target.value);

    if (e.target.value.length === 1 && index < 4) {
      otpRefs.current[index + 1].focus();
    } else if (e.target.value === "" && e.keyCode === 8 && index > 0) {
      // keyCode 8 is for backspace
      otpRefs.current[index - 1].focus();
    }
  };

  const handleFocus = (e) => {
    // Set the cursor to the end
    const valueLength = e.target.value.length;
    e.target.setSelectionRange(valueLength, valueLength);
  };

  const handleKeyNavigation = (e, index) => {
    if (e.keyCode === 37 && index > 0) {
      // left arrow key
      otpRefs.current[index - 1].focus();
    } else if (e.keyCode === 39 && index < 4) {
      // right arrow key
      otpRefs.current[index + 1].focus();
    }
  };

  const formik = useFormik({
    initialValues: {
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
    },
    validate: (values) => {
      let errors = {};
      if (
        !values.otp1 ||
        !values.otp2 ||
        !values.otp3 ||
        !values.otp4 ||
        !values.otp5
      ) {
        errors.otp = "OTP is incomplete.";
      }
      return errors;
    },
    onSubmit: async (values) => {
      setloading(true);
      setloadingIcon("pi pi-spin pi-spinner");
      const otp =
        values.otp1 + values.otp2 + values.otp3 + values.otp4 + values.otp5;
      await handlePostRequest(
        { otp, jwtToken },
        "zbizgateway/nonFin/verifyOTPToResetPwd"
      );
      handleSubmitOtp();
      setloading(false);
      setloadingIcon("pi pi-save");
      formik.resetForm();
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  return (
    <div className="Login__Body">
      <div className="container" id="container">
        <div class="form-container sign-in-container">
          <form
            action="#"
            className="Login__Form"
            onSubmit={formik.handleSubmit}
          >
            <div className="p-mb-4">
              <img src={LogoImg} alt="Js-connect" />
            </div>
            <div className="p-mb-4">
              <h3 className="forgetHeading">OTP CODE</h3>
            </div>

            <div className="p-mt-4">
              <div>
                <p>
                  Please enter the OTP code sent to your registered Mobile
                  Number / Email Address. <br />
                </p>
                <div>
                  {[1, 2, 3, 4, 5].map((_, index) => (
                    <Input
                      key={index}
                      maxLength="1"
                      ref={addRef}
                      onChange={(e) => handleInputChange(e, index)}
                      onKeyDown={(e) => handleKeyNavigation(e, index)}
                      onFocus={handleFocus}
                      value={formik.values[`otp${index + 1}`]}
                      name={`otp${index + 1}`}
                      type="text"
                    />
                  ))}
                  {getFormErrorMessage("otp1")}
                </div>
                <div className="p-mt-4">
                  <Button
                    className="Login__Button"
                    label="Submit OTP"
                    iconPos="right"
                  />
                  <Button
                    className="Login__Button"
                    label="Back"
                    onClick={() => {
                      history.push("/forgetpassword");
                    }}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const Input = styled.input`
  width: 40px;
  margin: 0 5px;
  text-align: center;
`;

export default SubmitOTP;
